import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/guide/training-cost/page.tsx");
